<div class="container">
  <h2>QBuilt Support</h2>

  <section class="delete-inspection-section">
    <h3>Clear an In-Progress Inspection from Selected Zone</h3>
    <p class="hint">
      Use this to remove an inspection that is currently in progress in QBuilt. Select a plant, zone,
      and serial number — the home will be cleared from the active inspections page.
    </p>

    <div class="selectors-row">
      <!-- Plant -->
      <mat-form-field appearance="outline">
        <mat-label>Plant Number</mat-label>
        <mat-select
          [(value)]="selectedPlant"
          (selectionChange)="onPlantChange($event.value)"
          [disabled]="deleting">
          @for (plant of plants; track plant) {
            <mat-option [value]="plant">{{ plant }}</mat-option>
          }
        </mat-select>
        @if (loading) {
          <mat-spinner matSuffix diameter="18" />
        }
      </mat-form-field>

      <!-- Zone -->
      <mat-form-field appearance="outline">
        <mat-label>Zone</mat-label>
        <mat-select
          [(value)]="selectedZone"
          (selectionChange)="onZoneChange($event.value)"
          [disabled]="!selectedPlant || loading || noDataForPlant || deleting">
          @for (zone of zones; track zone.Id) {
            <mat-option [value]="zone">{{ zone.Name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Serial -->
      <mat-form-field appearance="outline">
        <mat-label>Serial Number</mat-label>
        <mat-select
          [(value)]="selectedSerial"
          (selectionChange)="onSerialChange($event.value)"
          [disabled]="!selectedZone || noDataForZone || deleting">
          @for (serial of serials; track serial.serialNumber) {
            <mat-option [value]="serial">{{ serial.serialNumber }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    @if (noDataForPlant && selectedPlant && !loading) {
      <p class="no-data-msg">No zones found for plant {{ selectedPlant }}.</p>
    }
    @if (noDataForZone && selectedZone && !loading) {
      <p class="no-data-msg">No active inspections found for this zone.</p>
    }

    <div class="action-row">
      <button
        mat-raised-button
        color="warn"
        [disabled]="!selectedSerial || deleting"
        (click)="deleteSerial()">
        @if (deleting) {
          <mat-spinner diameter="18" />
        } @else {
          Delete Inspection
        }
      </button>
    </div>
  </section>

  <mat-divider class="section-divider"></mat-divider>

  <section class="delete-inspection-section db-delete-section">
    <h3>Delete Inspection from Database</h3>
    <div class="warning-banner">
      <strong>This is a permanent, irreversible database operation.</strong>
      This removes all inspection records, task executions, defects, deferrals, and attachments for the
      selected serial.<br>If the serial is currently listed as an active inspection in QBuilt, it will also
      be cleared from the active inspections list.
    </div>

    <div class="selectors-row">
      <!-- Plant -->
      <mat-form-field appearance="outline">
        <mat-label>Plant Number</mat-label>
        <mat-select
          [(value)]="dbSelectedPlant"
          (selectionChange)="onDbPlantChange($event.value)"
          [disabled]="dbDeleting">
          @for (plant of dbPlants; track plant) {
            <mat-option [value]="plant">{{ plant }}</mat-option>
          }
        </mat-select>
        @if (dbLoadingZones) {
          <mat-spinner matSuffix diameter="18" />
        }
      </mat-form-field>

      <!-- Zone -->
      <mat-form-field appearance="outline">
        <mat-label>Zone</mat-label>
        <mat-select
          [(value)]="dbSelectedZone"
          (selectionChange)="onDbZoneChange($event.value)"
          [disabled]="!dbSelectedPlant || dbLoadingZones || dbNoDataForPlant || dbDeleting">
          @for (zone of dbZones; track zone.Id) {
            <mat-option [value]="zone">{{ zone.Name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Serial Number -->
      <mat-form-field appearance="outline">
        <mat-label>Serial Number</mat-label>
        <mat-select
          [(value)]="dbSelectedSerial"
          [disabled]="!dbSelectedZone || dbLoadingSerials || dbNoDataForZone || dbDeleting">
          @for (serial of dbSerials; track serial) {
            <mat-option [value]="serial">{{ serial }}</mat-option>
          }
        </mat-select>
        @if (dbLoadingSerials) {
          <mat-spinner matSuffix diameter="18" />
        }
      </mat-form-field>
    </div>

    @if (dbNoDataForPlant && dbSelectedPlant && !dbLoadingZones) {
      <p class="no-data-msg">No zones found for plant {{ dbSelectedPlant }}.</p>
    }
    @if (dbNoDataForZone && dbSelectedZone && !dbLoadingSerials) {
      <p class="no-data-msg">No database inspections found for this zone.</p>
    }

    <div class="action-row">
      <button
        mat-raised-button
        color="warn"
        class="db-delete-btn"
        [disabled]="dbDeleteDisabled"
        (click)="deleteDatabaseInspection()">
        @if (dbDeleting) {
          <mat-spinner diameter="18" />
        } @else {
         Delete Inspection
        }
      </button>
    </div>
  </section>

  <mat-divider class="section-divider"></mat-divider>

  <section class="create-checklist-section">
    <h3>Create Checklist</h3>
    <p class="hint">Insert facility checklist JSON object</p>

    <textarea
      class="checklist-json-input"
      rows="10"
      [(ngModel)]="checklistJson"
      [disabled]="isCreatingChecklist"
      spellcheck="false"></textarea>

    @if (createChecklistError) {
      <p class="no-data-msg error-msg">{{ createChecklistError }}</p>
    }
    @if (createChecklistSuccess) {
      <p class="no-data-msg success-msg">Checklist created successfully.</p>
    }

    <div class="action-row">
      <button
        mat-raised-button
        color="primary"
        [disabled]="isCreatingChecklist"
        (click)="onCreateChecklist()">
        @if (isCreatingChecklist) {
          <mat-spinner diameter="18" />
        } @else {
          Create Checklist
        }
      </button>
    </div>
  </section>
</div>
